module.exports = __webpack_public_path__ + "static/meta-reductionism.136b9d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/meta-reductionism.jpg
// module id = 602
// module chunks = 114276838955818